import { Card, CardContent, Grid, Typography, Box, Container } from "@mui/material"
import { useContext } from "react";
import { AppContext } from "../context";
import { format, parse} from "date-fns";
import { capitalize } from "../services/utils"

export const CardUser = () => {
    const { logo, lead } = useContext<any>(AppContext);
    const cpf = lead.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
    const birthday = format(
        parse(lead.birthday, "yyyy-MM-dd", new Date()),
        "dd/MM/yyyy" 
        );
    return (
        <Container maxWidth='lg' sx={{my: 3, px:0}}>
        <Grid 
        container 
        direction='row' 
        columnSpacing={1}
        rowSpacing={1}
        display="flex"
        alignItems='center'
        sx={{justifyContent: 'center', maxWidth: 900,}}
        >
            <Grid sx={{width: '100%', p: 0}} item xs={12} lg={6} md={6}>
                <Card
                 sx={{
                     backgroundColor: '#F5F5F5', 
                     width: 350, 
                     maxWidth: '100%',
                     height: 200,
                     borderRadius: 5,
                     boxShadow: 5,
                     mx: 'auto'}}>
                    <CardContent sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '85%'}} >
                        <Box>
                            <img src={logo} alt="Logo" width='130px'/>
                        </Box>
                        <Box>
                            <Typography sx={{color: 'primary.main'}} variant='h6'>
                                {cpf}
                            </Typography>
                            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <Typography sx={{color: 'primary.main', mb:0}} variant='subtitle1'>
                               {capitalize(lead.name)}
                            </Typography>
                            <Typography sx={{color: 'primary.main', mt: 1}} variant='caption'>
                               powered by <strong>Bria</strong>
                            </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
            {/* <Grid xs={12} sm={0} item>
               <Box />
              </Grid> */}
            <Grid item xs={12} lg={6} md={6}>
            <Card
                 sx={{
                     backgroundColor: '#F5F5F5', 
                     width: 350, 
                     maxWidth: '100%',
                     height: 200,
                     borderRadius: 5,
                     boxShadow: 5}}>
                    <CardContent sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '100%'}} >
                        
                        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '85%'}}>
                            <Box>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle1'>
                                    Data de Nascimento:
                                </Typography>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle2'>
                                    {birthday}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle1'>
                                    Produto:
                                </Typography>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle2'>
                                    {lead.selected_product}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle1'>
                                    Abrangência:
                                </Typography>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle2'>
                                      Nacional
                                </Typography>
                            </Box>
                                    
                        </Box>
                        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '85%'}}>
                            <Box>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle1'>
                                    Telefone:
                                </Typography>
                                <Typography sx={{color: 'primary.main'}} variant='subtitle2'>
                                0800 9423 040
                                </Typography>
                            </Box>
                            <Box sx={{mt: 6}}>
                                <Typography sx={{color: 'primary.main', mt: 1, }} variant='caption'>
                                    powered by <strong>Bria</strong>
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
        </Container>
    )
}